<template>
    <HomeContentLayout>
        <div class="test">这是工作台</div>
    </HomeContentLayout>
</template>

<script>
    export default {
        name: "WorkPlace",
        mounted() {
        }
    }
</script>

<style scoped>
.test{
    background-color: blue;
    height:1200px;
}
</style>
